"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
var C_ASSERT = 'background: #f00; color: #ffcfcc';
var C_LOG = 'background: #11a60055; color: #fff';
var C_WARN = 'background: #c4c41055; color: #fff';
var C_ERROR = 'background: #c4281055; color: #fff';
var Logger = /** @class */ (function () {
    function Logger() {
    }
    Logger.init = function (gameName) {
        this._prefix = "%c[".concat(gameName, "]: ");
    };
    Logger.assert = function (assertion, message) {
        console.assert(assertion, "".concat(this._prefix).concat(message), C_ASSERT, '');
    };
    Logger.log = function (message) {
        var context = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            context[_i - 1] = arguments[_i];
        }
        console.log.apply(console, __spreadArray(["".concat(this._prefix).concat(message), C_LOG], context, false));
    };
    Logger.warn = function (message) {
        var context = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            context[_i - 1] = arguments[_i];
        }
        console.warn.apply(console, __spreadArray(["".concat(this._prefix).concat(message), C_WARN], context, false));
    };
    Logger.error = function (message) {
        var context = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            context[_i - 1] = arguments[_i];
        }
        console.error.apply(console, __spreadArray(["".concat(this._prefix).concat(message), C_ERROR], context, false));
    };
    Logger.clear = function () {
        console.clear();
    };
    Logger._prefix = '%c[ENGINE]: ';
    return Logger;
}());
exports.Logger = Logger;
